import React from 'react';
import { styled } from '@mui/material';
import {
  AccountBalanceWalletOutlined,
  PaymentsOutlined,
  QueryStatsOutlined,
  TrendingUpOutlined,
} from '@mui/icons-material';
import ReportMetricCard from 'components/report/ReportMetricCard';
import { moneyFormat } from 'helpers/moneyFormat';
import { useReportSurgerie } from './hooks/useReportSurgerie';

const Container = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: theme.spacing(1.5),
  alignItems: 'stretch',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

const ReportSurgerieTotal: React.FC = () => {
  const { surgeries } = useReportSurgerie();
  const filtered = surgeries.filter(surgerie => surgerie.status !== 'deleted');
  const closed = filtered.filter(surgerie => surgerie.status === 'closed');
  const totalValue = filtered.reduce((acc, surgerie) => acc + surgerie.value_total, 0);
  const averageValue = filtered.length > 0 ? totalValue / filtered.length : 0;
  const totalPaid = filtered.reduce((acc, surgerie) => acc + surgerie.value_paid, 0);
  const pendingValue = Math.max(totalValue - totalPaid, 0);

  return (
    <Container>
      <ReportMetricCard
        icon={<AccountBalanceWalletOutlined />}
        label="Valor vendido"
        value={moneyFormat(totalValue)}
        helper={`${closed.length} fechados de ${filtered.length} orçamentos`}
        tone="primary"
      />
      <ReportMetricCard
        icon={<TrendingUpOutlined />}
        label="Ticket méio"
        value={moneyFormat(averageValue)}
        helper="Média por orçamento no filtro atual"
        tone="success"
      />
      <ReportMetricCard
        icon={<PaymentsOutlined />}
        label="Total pago"
        value={moneyFormat(totalPaid)}
        helper={`${moneyFormat(pendingValue)} ainda pendente`}
        tone={pendingValue > 0 ? 'warning' : 'info'}
      />
      <ReportMetricCard
        icon={<QueryStatsOutlined />}
        label="Volume"
        value={filtered.length}
        helper="Orçamentos cirúrgicos no período"
        tone="info"
      />
    </Container>
  );
};

export default ReportSurgerieTotal;
